import { observable } from 'mobx';

export default window.STATE = observable({
	mode: 'lake',
	showLakeMaps: false,
	currentDam: undefined,
	currentLake: undefined,
	damFilter: {
		county: undefined,
		surfaceArea: {
			from: undefined,
			to: undefined
		},
		volume: {
			from: undefined,
			to: undefined
		},
		year: {
			from: undefined,
			to: undefined
		},
		includeMissingValues: true
	}
}, {}, { deep: false });
